// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import jQuery from 'jquery';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import VueCurrencyFilter from 'vue-currency-filter';
import moment from 'moment';
import VueMoment from 'vue-moment';
import VueLoading from 'vuex-loading';
import md5 from 'js-md5';

import router from './router';
import store from './store';
import App from './App';

import { APP_NAME, API_VERSION, API_STANDARDS_TREE, SECRET_KEY, TOKEN_EXPIRE_NOTICE_KEY } from './constants';

import './styles/style.scss';
import './styles/element.scss';

/* eslint no-multi-assign: 0 */
window.$ = window.jQuery = jQuery;

Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(VueCurrencyFilter, {
  symbol: 'HK$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolSpacing: false,
});
moment.locale('zh-hk');
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueLoading);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vueLoading: new VueLoading({ useVuex: true }),
  components: { App },
  template: '<App/>',
  created() {
    this.axios.defaults.headers.common.Accept = `application/${API_STANDARDS_TREE}.${APP_NAME}.${API_VERSION}+json`;
    this.axios.defaults.headers.common['Conetent-Type'] = 'application/x-www-form-urlencoded';
    this.axios.interceptors.request.use((config) => {
      /* eslint no-param-reassign: 0 */
      const token = this.$store.state.member.token;
      const expiresTime = this.$store.state.member.expiresTime;
      // 检查token是否过期
      if (token) {
        if (expiresTime > Date.now()) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          this.$store.dispatch('logout');
        }
      }

      const ts = Date.now();
      config.headers.Signature = md5([location.hostname, navigator.userAgent, ts, SECRET_KEY].join('|'));
      config.headers.ts = ts;
      return config;
    });
    this.axios.interceptors.response.use((response) => {
      // token 過期提醒
      const tokenExpireNotice = response.headers['token-expire-remaining'];
      if (tokenExpireNotice) {
        sessionStorage.setItem(TOKEN_EXPIRE_NOTICE_KEY, tokenExpireNotice);
      }
      // 设置用户和服务器时间差
      if (!this.$store.state.app.timeDiff) {
        this.$store.dispatch('setTimeDiff', ~~(Date.now() / 1000) - Number(response.headers.timestamp));
      }
      return response;
    }, (error) => {
      if (error.response) {
        /* eslint default-case:0 */
        switch (error.response.status) {
          case 401:
            return this.$store.dispatch('logout').then(() => {
              this.$router.push({ name: 'login' });
            });
          case 500:
            //
            break;
        }
      }
      return Promise.reject(error);
    });

    if (this.$route.name === 'admin-login') {
      const params = { code: this.$route.query.code };
      this.$store.dispatch('adminLogin', params).then(() => {
        this.$router.push({ name: 'index' });
      }).catch((e) => {
        if (e.response) {
          this.$notify({
            title: '登錄失敗',
            message: e.response.data.message,
            type: 'error',
          });
        }
      });
    }
  },
});



// WEBPACK FOOTER //
// ./src/main.js